<template>
      <b-modal v-model="videoShow"
               centered cancel-disabled hide-footer>
        <video class="cs-home-video-demonstration align-content-center" controls autoplay>
          <source :src="getVideoSrcPath()" type="video/mp4">
        </video>
      </b-modal>
</template>

<script>
import { getVideoSrc } from '@/utils/assets';

export default {
  name: 'VideoDemonstrationModal',
  props: {
    videoName: String,
  },
  data() {
    return {
      videoShow: false,
    };
  },
  methods: {
    getVideoSrcPath() {
      return getVideoSrc(this.videoName);
    },
  },
};
</script>
<style scoped>
.cs-home-video-demonstration {
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
</style>
